<template>
  <section>
    <div class="section-header">
      <div class="section-header__call">
        <h3>
          <span v-if="titleLightOne" v-text="titleLightOne" class="light"></span>&nbsp;
          <span v-if="titleHeavyOne" v-text="titleHeavyOne" class="heavy"></span>&nbsp;
          <span v-if="titleLightTwo" v-text="titleLightTwo" class="light"></span>&nbsp;
          <span v-if="titleHeavyTwo" v-text="titleHeavyTwo" class="heavy"></span>&nbsp;
          <span v-if="titleLightThree" v-text="titleLightThree" class="light"></span>&nbsp;
          <span v-if="titleHeavyThree" v-text="titleHeavyThree" class="heavy"></span>
        </h3>
        <p v-if="subtext" v-text="subtext"></p>
      </div>
    </div>
    <div class="section-content" data-aos="fade-in" data-aos-offset="100">
      <slot/>
    </div>
  </section>
</template>

<script>
export default {
  name: 'VisualDataSection',
  props: {
    titleLightOne: String,
    titleHeavyOne: String,
    titleLightTwo: String,
    titleHeavyTwo: String,
    titleLightThree: String,
    titleHeavyThree: String,
    subtext: String,
    geometry: Boolean
  }
};
</script>
